import { useEffect, useState } from 'react';
import { getClientIdCookie } from '../lib/cognito';

const useGetClientIdCookie = (): [boolean, boolean] => {
  const [clientId, setClientId] = useState<boolean>(false);
  const [hasLoadedCookie, setHasLoadedCookie] = useState<boolean>(false);
  useEffect(() => {
    const fetchCookie = async (): Promise<void> => {
      const cookie = await getClientIdCookie();
      setClientId(cookie);
      setHasLoadedCookie(true);
    };
    if (!hasLoadedCookie) {
      fetchCookie();
    }
  }, [clientId, hasLoadedCookie]);
  return [clientId, hasLoadedCookie];
};

export default useGetClientIdCookie;
